import React from "react";
import "./HomeServices.css";
import { homeServicesList } from "../../utils/homeServices";
import HomeserviceCard from "./HomeserviceCard";
import { Link } from "react-router-dom";

const HomeServices = () => {
  return (
    <div className="HomeServices-container">
      <span className="homeserviceHead">Our Featured Services</span>
      <span className="homeBannerPara">
        Techni Trust Technical Services provides expert solutions for
        electrical, plumbing, HVAC, painting, and decorative works. We also
        offer flooring, waterproofing, smart home automation, and more, ensuring
        reliable and efficient services for every space.
      </span>
      <div className="HomeServices-deatils">
        {homeServicesList.map((list, index) => (
          <HomeserviceCard
            key={index}
            ServiceName={list.name}
            Icon={list.Icon}
            desc={list.desc}
          />
        ))}
      </div>
      <Link to={"/services"}>
        <button class="button">Explore More </button>
      </Link>
    </div>
  );
};

export default HomeServices;
